import styled from "styled-components";
export const LabelSmall = styled.label `
    font-size: 12px;
    font-weight: 500;
    word-break: break-word;
    margin-left: 0.7rem;
    margin-bottom: 3px;
    display: inline-block;
`;
